import type { UserMetadata } from '#/domain/user/User'
import type { UserRepository } from '#/domain/user/UserRepository'

export class UpdateUserMeUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(metadata: UserMetadata): Promise<void> {
    return this.repository.updateMe(metadata)
  }
}
